import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Vehicule } from 'src/app/user/user.model';
import { MatDialog } from '@angular/material/dialog';
import { UserServiceImpl } from 'src/app/user/service/user.service';
import { Subject } from 'rxjs';
import { VehiculeModalComponent } from '../vehicule-modal/vehicule-modal.component';

@Component({
    selector: 'app-vehicle-list',
    templateUrl: './user-vehicle-list.component.html',
    styleUrls: ['./user-vehicle-list.component.scss'],
})
export class VehicleListComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();
    toggleView = false;

    @Input() vehicles: Vehicule[];
    constructor(
        public dialog: MatDialog,
        public userService: UserServiceImpl,
    ) {}

    ngOnInit(): void {}
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    editVehicule(vehicule: Vehicule) {
        const dialogRef = this.dialog.open(VehiculeModalComponent, {
            data: { value: 1, vehicle: vehicule },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.vehicles.forEach((item: Vehicule) => {
                if (item.id === result.data.id) {
                    item.model = result.data.model;
                    item.year = result.data.year;
                    item.make = result.data.make;
                    item.plate = result.data.plate;
                }
            });
            this.userService.updateUserVehicule(this.vehicles);
        });
    }

    openDelete(vehicule: Vehicule) {
        const dialogRef = this.dialog.open(VehiculeModalComponent, {
            data: { value: 2, vehicle: vehicule },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result.event === 'Save') {
                this.vehicles = this.vehicles.filter((each) => {
                    return each.id !== result.data.id;
                });
                this.userService.deleteUserVehicule(result.data.id);
            }
        });
    }

    openUdesView() {
        this.toggleView = !this.toggleView;
    }
}
